module.exports = __webpack_public_path__ + "static/img/伙伴客户-广州医科大三.e613b2c4.png";